/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskSeverityEnum } from './RiskSeverityEnum';
import {
    RiskSeverityEnumFromJSON,
    RiskSeverityEnumFromJSONTyped,
    RiskSeverityEnumToJSON,
    RiskSeverityEnumToJSONTyped,
} from './RiskSeverityEnum';
import type { RiskStatusEnum } from './RiskStatusEnum';
import {
    RiskStatusEnumFromJSON,
    RiskStatusEnumFromJSONTyped,
    RiskStatusEnumToJSON,
    RiskStatusEnumToJSONTyped,
} from './RiskStatusEnum';

/**
 * Serializer for Risk model with team context
 * @export
 * @interface PatchedRisk
 */
export interface PatchedRisk {
    /**
     * 
     * @type {number}
     * @memberof PatchedRisk
     */
    readonly id?: number;
    /**
     * Brief title describing the risk
     * @type {string}
     * @memberof PatchedRisk
     */
    title?: string;
    /**
     * Detailed description of the risk
     * @type {string}
     * @memberof PatchedRisk
     */
    description?: string;
    /**
     * Level of risk severity
     * 
     * * `LOW` - Low
     * * `MEDIUM` - Medium
     * * `HIGH` - High
     * * `CRITICAL` - Critical
     * @type {RiskSeverityEnum}
     * @memberof PatchedRisk
     */
    severity?: RiskSeverityEnum;
    /**
     * Current status of the risk
     * 
     * * `ACTIVE` - Active
     * * `MITIGATED` - Mitigated
     * * `RESOLVED` - Resolved
     * @type {RiskStatusEnum}
     * @memberof PatchedRisk
     */
    status?: RiskStatusEnum;
    /**
     * Associated VIP profile
     * @type {number}
     * @memberof PatchedRisk
     */
    profile?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedRisk
     */
    readonly profileName?: string;
    /**
     * Source of the risk information
     * @type {string}
     * @memberof PatchedRisk
     */
    source?: string;
    /**
     * Steps taken to mitigate the risk
     * @type {string}
     * @memberof PatchedRisk
     */
    mitigation?: string;
    /**
     * URL link to the news article
     * @type {string}
     * @memberof PatchedRisk
     */
    link?: string | null;
    /**
     * Domain of the article source
     * @type {string}
     * @memberof PatchedRisk
     */
    domain?: string | null;
    /**
     * Displayed URL for the article
     * @type {string}
     * @memberof PatchedRisk
     */
    displayedLink?: string | null;
    /**
     * Short excerpt from the article
     * @type {string}
     * @memberof PatchedRisk
     */
    snippet?: string | null;
    /**
     * List of highlighted words in the snippet
     * @type {any}
     * @memberof PatchedRisk
     */
    snippetHighlightedWords?: any | null;
    /**
     * Base64 encoded favicon of the source website
     * @type {string}
     * @memberof PatchedRisk
     */
    favicon?: string | null;
    /**
     * Base64 encoded thumbnail image for the article
     * @type {string}
     * @memberof PatchedRisk
     */
    thumbnail?: string | null;
    /**
     * Original publication date of the news article or content
     * @type {string}
     * @memberof PatchedRisk
     */
    publishDate?: string | null;
    /**
     * When the risk was created
     * @type {Date}
     * @memberof PatchedRisk
     */
    readonly createdAt?: Date;
    /**
     * When the risk was last updated
     * @type {Date}
     * @memberof PatchedRisk
     */
    readonly updatedAt?: Date;
    /**
     * Type of the risk
     * @type {string}
     * @memberof PatchedRisk
     */
    type?: string | null;
}



/**
 * Check if a given object implements the PatchedRisk interface.
 */
export function instanceOfPatchedRisk(value: object): value is PatchedRisk {
    return true;
}

export function PatchedRiskFromJSON(json: any): PatchedRisk {
    return PatchedRiskFromJSONTyped(json, false);
}

export function PatchedRiskFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedRisk {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'severity': json['severity'] == null ? undefined : RiskSeverityEnumFromJSON(json['severity']),
        'status': json['status'] == null ? undefined : RiskStatusEnumFromJSON(json['status']),
        'profile': json['profile'] == null ? undefined : json['profile'],
        'profileName': json['profile_name'] == null ? undefined : json['profile_name'],
        'source': json['source'] == null ? undefined : json['source'],
        'mitigation': json['mitigation'] == null ? undefined : json['mitigation'],
        'link': json['link'] == null ? undefined : json['link'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'displayedLink': json['displayed_link'] == null ? undefined : json['displayed_link'],
        'snippet': json['snippet'] == null ? undefined : json['snippet'],
        'snippetHighlightedWords': json['snippet_highlighted_words'] == null ? undefined : json['snippet_highlighted_words'],
        'favicon': json['favicon'] == null ? undefined : json['favicon'],
        'thumbnail': json['thumbnail'] == null ? undefined : json['thumbnail'],
        'publishDate': json['publish_date'] == null ? undefined : json['publish_date'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'type': json['type'] == null ? undefined : json['type'],
    };
}

  export function PatchedRiskToJSON(json: any): PatchedRisk {
      return PatchedRiskToJSONTyped(json, false);
  }

  export function PatchedRiskToJSONTyped(value?: Omit<PatchedRisk, 'id'|'profile_name'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'severity': RiskSeverityEnumToJSON(value['severity']),
        'status': RiskStatusEnumToJSON(value['status']),
        'profile': value['profile'],
        'source': value['source'],
        'mitigation': value['mitigation'],
        'link': value['link'],
        'domain': value['domain'],
        'displayed_link': value['displayedLink'],
        'snippet': value['snippet'],
        'snippet_highlighted_words': value['snippetHighlightedWords'],
        'favicon': value['favicon'],
        'thumbnail': value['thumbnail'],
        'publish_date': value['publishDate'],
        'type': value['type'],
    };
}

